export default __webpack_public_path__ + "static/media/services04.e11dbda9.jpg";